/* eslint-disable array-callback-return */
/**
 * 消息盒子组件
 */
import React, { useCallback, useEffect } from "react";
import { MessageDateFormType } from "@/types/chat/enum";
import "./index.less";
import { ChatMessage, Session } from "@/types/chat";
import ChatMessageItem from "@/baseComponents/Chat/message/Item/ChatItem";
import { getMessageDateFormat } from "@/utils/date";
import { MessageEmitCategory } from "@jd/jdee.im.sdk/lib/es/enum/MessageEmitType";
import SysMessageItem from "@/baseComponents/Chat/message/Item/SysItem";
import { ChatMessageType } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import SysMessage from "@/components/chat/message/Sys";
import { useTranslation } from "react-i18next";
import Revoke from "@/components/chat/message/Revoke";
import Context from "@/components/chat/context";
import bus from "@/utils/bus";
import { connect } from "dvajs";
import { FocusSDK } from "@/utils";
interface MessageBoxProps {
  messages: ChatMessage[];
  session?: Session;
  getLock: Function;
  unLock: Function;
  getCurrentMessageId: Function;
  setCurrentMessageId: Function;
  notPersonalCalendar?: boolean;
}
interface DvaDispatchProps {
  setVoiceMessageMap: Function;
  updateSessionMessageMid: Function;
}
let visbol: boolean;
type IProps = Readonly<MessageBoxProps & DvaDispatchProps>;
function MessageBox(props: IProps) {
  const { messages, session, setVoiceMessageMap, notPersonalCalendar = false } = props;
  const { groupRosterIdentity } = React.useContext(Context);
  const { t } = useTranslation("chat");

  // 语音转文字
  useEffect(() => {
    return () => {
      setVoiceMessageMap([]);
    };
  }, [setVoiceMessageMap]);

  const getSendTime = useCallback(
    (message) => {
      const sendTime = getMessageDateFormat(
        message.timestamp,
        MessageDateFormType.DATE_AGGREGATION
      );
      return <div className="time">{sendTime}</div>;
    },
    [t] // eslint-disable-line
  );

  const changeVisbol = (data: boolean) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    visbol = data;
  };

  useEffect(() => {
    bus.on("message:Box", changeVisbol);
    return () => {
      bus.off("message:Box", changeVisbol);
    };
  }, []);
  if (messages.length > 0) {
    return (
      <div className="message-node">
        {messages.map((message: any, index) => {
          if (message.category === MessageEmitCategory.SYSTEM) {
            if (
              message.type === ChatMessageType.SYS &&
              message.flag !== 100 &&
              !message.data?._sys_msg_type_
            ) {
              return <SysMessage key={`s-2-${message.id}`} message={message} />;
            } else {
              return <SysMessageItem key={`s-${message.id}`} message={message} />;
            }
          } else if (message.category === MessageEmitCategory.CHAT_MESSAGE) {
            if (message.revoke === 1 && !message.plusList) {
              return (
                <Revoke
                  key={`r-${message.id}`}
                  message={message}
                  sessionType={session?.sessionType}
                />
              );
            } else {
              return (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    display: message.plusList && "flex",
                    justifyContent: message.plusList && "center"
                  }}
                  className={
                    visbol === true && !message.mid && message.type === ChatMessageType.TEXT
                      ? "mergeUp"
                      : ""
                  }
                >
                  <ChatMessageItem
                    key={`c-${message.id}-${message.timestamp}`}
                    groupRosterIdentity={groupRosterIdentity}
                    sendTime={getSendTime(messages[0])}
                    prevMessage={index > 0 ? messages[index - 1] : null}
                    message={message}
                    getLock={props.getLock}
                    unLock={props.unLock}
                    getCurrentMessageId={props.getCurrentMessageId}
                    setCurrentMessageId={props.setCurrentMessageId}
                    updateSessionMessageMid={props.updateSessionMessageMid}
                    notPersonalCalendar={notPersonalCalendar}
                  />
                </div>
              );
            }
          } else {
            return null;
          }
        })}
      </div>
    );
  }
  return null;
}

// export default MessageBox;
function mapStateToProps() {
  return {};
}
function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    setVoiceMessageMap(payload: boolean) {
      dispatch({ type: "chat/setVoiceMessageMap", payload });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MessageBox);
